export default __webpack_public_path__ + "static/media/oasis_header.76ffa172.svg";